webpackJsonp([75105661925852],{

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/background.cca532c4.jpg";

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _background = __webpack_require__(481);
	
	var _background2 = _interopRequireDefault(_background);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjektyPage = function (_React$Component) {
	  _inherits(ProjektyPage, _React$Component);
	
	  function ProjektyPage() {
	    _classCallCheck(this, ProjektyPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ProjektyPage.prototype.render = function render() {
	    var data = this.props.data;
	    var projekt = data.allMarkdownRemark.edges;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'section',
	        {
	          className: 'hero is-info is-small ', style: {
	            background: "url(" + _background2.default + ")",
	            backgroundSize: "cover",
	            backgroundPosition: "bottom"
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'hero-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'columns' },
	              _react2.default.createElement(
	                'div',
	                { className: 'column' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mytitle' },
	                  'Nasze Projekty'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          projekt.filter(function (projekt) {
	            return projekt.node.frontmatter.templateKey === 'projekt-post';
	          }).map(function (_ref) {
	            var projekt = _ref.node;
	            return _react2.default.createElement(
	              'div',
	              {
	                className: 'content',
	                style: { border: '1px solid #eaecee', padding: '2em 4em' },
	                key: projekt.id
	              },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { className: 'has-text-primary', to: projekt.fields.slug },
	                  projekt.frontmatter.title
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  ' \u2022 '
	                ),
	                _react2.default.createElement(
	                  'small',
	                  null,
	                  projekt.frontmatter.date
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                projekt.excerpt,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { className: 'button is-small', to: projekt.fields.slug },
	                  'Czytaj Wi\u0119cej \u2192'
	                )
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return ProjektyPage;
	}(_react2.default.Component);
	
	exports.default = ProjektyPage;
	
	
	ProjektyPage.propTypes = {
	  data: _propTypes2.default.shape({
	    allMarkdownRemark: _propTypes2.default.shape({
	      edges: _propTypes2.default.array
	    })
	  })
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projekty-js-a086f7b66948e174711f.js